var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5 5.77778C5 5.34822 5.34822 5 5.77778 5H18.2222C18.6518 5 19 5.34822 19 5.77778V7.78895C19 7.99522 18.9181 8.19306 18.7722 8.33892L13.7834 13.3277C13.6375 13.4736 13.5556 13.6714 13.5556 13.8777V15.8889L10.4444 19V13.8777C10.4444 13.6714 10.3625 13.4736 10.2166 13.3277L5.22781 8.33892C5.08194 8.19306 5 7.99522 5 7.78895V5.77778Z",
    stroke: "#666666",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.d81872575e2f3410824065fc71e6f8dd.svg";
export { ForwardRef as ReactComponent };